import React from "react";
import { useSettings } from "@/context/SettingsContext";

export const Logo = ({ compact = false }) => {
  const { settings } = useSettings();
  return (
    <div className="flex items-center gap-3" data-testid="app-logo">
      <div
        className="relative grid h-10 w-10 shrink-0 place-items-center rounded-xl shadow-sm"
        style={{ backgroundColor: "hsl(var(--brand-accent))" }}
      >
        <svg viewBox="0 0 24 24" className="h-6 w-6 text-white" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2 4 5v6c0 5 3.5 8.5 8 11 4.5-2.5 8-6 8-11V5l-8-3Z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      </div>
      {!compact && (
        <div className="leading-tight">
          <div className="font-display text-sm font-extrabold tracking-tight text-white">
            {settings?.firm_name || "PRO ACCOUNTANTS"}
          </div>
          <div className="text-[10px] font-medium uppercase tracking-wider text-slate-400">
            {settings?.tagline || "London"}
          </div>
        </div>
      )}
    </div>
  );
};
